import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "aStar",
  "use": "aStar-usage",
  "viewBox": "0 0 11.11 11.11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.11 11.11\" fill=\"currentColor\" id=\"aStar\">\n\t<path d=\"M4.94 5.79h1.1L5.5 4.48zm.04-2.34H6.1l1.69 3.8H6.62l-.33-.78H4.67l-.34.77H3.31zm-.54-2.04L2.76.74l-.23 1.78-1.79.22.67 1.68L0 5.55 1.4 6.7.73 8.37l1.8.22.21 1.8 1.7-.67 1.12 1.39 1.12-1.4 1.69.67.22-1.78 1.79-.22L9.7 6.7l1.4-1.15-1.4-1.14.67-1.67-1.8-.22-.21-1.8-1.7.67-1.11-1.4-1.13 1.4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol